import { ReactElement } from 'react';

import { formatArchived, formatDateRange } from '~/utils/date/date';
import { ICeArchivedExemption, ICeExemption } from '~/services/api/communityEngagement/types';

import ArchivedSection from '~/ui/pages/Clients/reusable/CommunityEngagement/components/ArchivedSection';
import DocumentList from '~/ui/pages/Clients/reusable/CommunityEngagement/components/DocumentList';
import ReadOnlyArchivedRow from './ReadOnlyArchivedRow';

import styles from './PlanEngagement.module.scss';

interface IExemptionListProps {
  exemptions: ICeExemption[];
  archivedExemptions: ICeArchivedExemption[];
}

const ExemptionList = ({ exemptions, archivedExemptions }: IExemptionListProps): ReactElement => (
  <section aria-label="Exemption" className={styles.block}>
    {exemptions.length > 0 && (
      <div>
        {exemptions.map(exemption => (
          <div key={exemption.id} className={styles.entry}>
            <div className={styles.entrySummary}>
              <span className={styles.entryAmount}>{exemption.category.name}</span>
              <span className={styles.entryReported}>
                {formatDateRange(exemption.effectiveDate, exemption.expirationDate)}
              </span>
            </div>
            <div className={styles.entryDocuments}>
              <DocumentList documents={exemption.documents} />
            </div>
          </div>
        ))}
      </div>
    )}
    {archivedExemptions.length > 0 && (
      <ArchivedSection>
        {archivedExemptions.map(archived => (
          <ReadOnlyArchivedRow
            key={archived.id}
            title={archived.category.name}
            subtitle={formatArchived(archived.archivedOn)}
          />
        ))}
      </ArchivedSection>
    )}
  </section>
);

export default ExemptionList;
